import { motion } from "framer-motion";
import { CalendarX, CurrencyInr, Megaphone, Notebook, Trophy, Bell, WhatsappLogo } from "@phosphor-icons/react";
import { useApi, fmtDate } from "../lib/api";
import { useT } from "../lib/i18n";
import { PageHeader, GlassCard, Loader, Empty, fadeUp } from "../components/kit";

const ICONS = { attendance: [CalendarX, "text-rose-300"], fee: [CurrencyInr, "text-orange-300"], notice: [Megaphone, "text-blue-300"], homework: [Notebook, "text-emerald-300"], result: [Trophy, "text-amber-300"] };

export default function Updates() {
  const { t } = useT();
  const { data, loading } = useApi("/my/updates");
  return (
    <div>
      <PageHeader eyebrow="Inbox" title={t("Updates")} subtitle="Alerts about attendance, fees, homework, notices and results — also sent to your WhatsApp number." />
      {loading ? <Loader /> : !data?.length ? <GlassCard><Empty /></GlassCard> : (
        <div className="space-y-3">
          {data.map((n, i) => {
            const [I, c] = ICONS[n.kind] || [Bell, "text-zinc-300"];
            return (
              <motion.div key={n.id} {...fadeUp(i)}>
                <GlassCard hover className="p-5 flex items-start gap-4" data-testid={`update-${n.id}`}>
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-white/5 border border-white/10 ${c}`}><I size={20} weight="duotone" /></span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center justify-between gap-2"><span className="font-semibold text-white">{n.title}</span><span className="text-xs text-zinc-500 whitespace-nowrap">{fmtDate(n.created_at)}</span></div>
                    <p className="mt-1 text-sm text-zinc-400">{n.message}</p>
                    <span className="mt-2 inline-flex items-center gap-1 text-[11px] text-emerald-300/80"><WhatsappLogo size={12} /> WhatsApp {n.status}</span>
                  </div>
                </GlassCard>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
}
